import { IconsProps } from '@/types/shared'
import React from 'react'

const icons: { [key: string]: React.FC<IconsProps> } = {}

// Using require.context for Rspack/Webpack compatibility
// @ts-expect-error - Webpack/Rspack-specific API
const context = require.context('./', true, /\.(js|jsx|ts|tsx)$/)
context.keys().forEach((key: string) => {
    if (key === './index.ts') return // Skip self
    const iconName = key.replace('./', '').replace(/\.\w+$/, '')
    const module = context(key) as { default: React.FC<IconsProps> }
    if (module.default) {
        icons[iconName] = module.default
    }
})

export default icons
